module.exports = __webpack_public_path__ + "img/2.de627f93.jpg";